/**
 * How the two action slots of a users-overview row render.
 *
 * Both slots always occupy their space so the icons stay aligned across rows:
 * - 'link'     actionable icon
 * - 'disabled' muted, non-clickable icon with an explanatory tooltip
 * - 'hidden'   invisible placeholder
 *
 * The employee-edit target (`/employee-management`) is scoped to the active
 * period and module, so it is only actionable while `employeeInfo.in_current_period` holds.
 */
export function actionSlots(user) {
  // login access is decided by the backend (LIX-1812), not guessed from roles or preferences
  const hasLogin = user?.is_login_enabled === true;
  const hasModules = (user?.modules || []).length > 0;

  // an employee-only person outside every module has nothing to edit anywhere
  if (!hasLogin && !hasModules) return { userEdit: 'hidden', employeeEdit: 'hidden' };

  let employeeEdit = 'hidden';
  if (user?.employeeInfo) employeeEdit = user.employeeInfo.in_current_period ? 'link' : 'disabled';

  return { userEdit: hasLogin ? 'link' : 'hidden', employeeEdit };
}

const ADMIN_AND_HR_ROLES = [
  'it-admin',
  'application-admin',
  'module-admin-lob',
  'module-admin-db',
  'hr',
  'hr-lob',
  'hr-db',
];

/**
 * Which halves of the roles cell actually carry an icon. The divider between them is only a
 * divider when there is something on both sides; on the many rows that hold neither an admin
 * role nor a group it was a bar hanging in an empty cell.
 */
export function roleIconSides(user) {
  const roles = user?.roles || [];

  const admin = roles.some(role => ADMIN_AND_HR_ROLES.includes(role));

  const evaluator = roles.some(role => role.includes('evaluator')) && (user?.groups_evaluating || []).length > 0;
  const secondaryEvaluator = (user?.groups_secondary_evaluating || []).length > 0;
  const reviewer = roles.some(role => role.includes('reviewer')) && (user?.groups_reviewing || []).length > 0;

  return { admin, group: evaluator || secondaryEvaluator || reviewer };
}
